module.exports = __webpack_public_path__ + "static/img/xfh.a989584.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/xfh.png
// module id = jfIG
// module chunks = 1